// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import slideshow from './js/widgets/slideshow.js';
import seoWidget from './js/widgets/seoWidget.js';
import cardWidget from './js/widgets/cardWidget.js';
import autoEvent from './js/widgets/autoEvent.js';
import scrollerSponsorsDouble from './js/widgets/scrollerSponsorsDouble.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  customTicketButton();
  if (globalThis.location.pathname === '/') {
    slideshow();
    seoWidget();
    cardWidget();
    autoEvent();
    scrollerSponsorsDouble('scroller-sponsors-first', scrollerSponsorsFirstOpts, 6);
    scrollerSponsorsDouble('scroller-sponsors-second', scrollerSponsorsSecondOpts, 6);
  }
});
